import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RECEIVE_ACTION_TYPE } from "types/enums/receive-action-type";

type State = {
  reload: boolean;
  tinh: any;
  huyen: any;
  xa: any;
};

const initialState: State = {
  reload: false,
  tinh: 0,
  huyen: 0,
  xa: 0,
};

export const rReloadSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    setReload: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, reload: action.payload };
    },
    setTinh: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, tinh: action.payload };
    },
    setHuyen: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, huyen: action.payload };
    },
    setXa: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, xa: action.payload };
    },
  },
});

export const { setReload, setTinh, setHuyen, setXa } = rReloadSlice.actions;

export default rReloadSlice.reducer;
